export const EventTrackLabel = {
  ADD_PAYMENT_INFO : 'add_payment_info',
  ADD_TO_CART : 'add_to_cart',
  BEGIN_CHECKOUT : 'begin_checkout',
  PURCHASE : 'purchase',
  LOGIN : 'login',
  VIEW_PROMOTION : 'view_promotion',
  CANCELED_TRANSACTION : 'Transação Cancelada',
  VIEW_ITEM : 'view_item',
  SELECT_ITEM : 'select_item',
};

type EventTrackLabelType = typeof EventTrackLabel[keyof typeof EventTrackLabel];

export type { EventTrackLabelType };
